export const isRowChecked = ({ row, selectMode, selected }) => {
  if (selectMode) {
    if (selectMode === 'all') {
      return true
    }

    const isChecked = selected.some((x) => x.id === row.id)

    if (selectMode === 'only') {
      return isChecked
    }

    if (selectMode === 'exclude') {
      return !isChecked
    }
  }

  return false
}

export const resolveSortBy = (column, field) => {
  if (column) {
    return column.sortKey || field
  }

  return null
}

export const resolveSortDirection = (column, order) => {
  if (column) {
    return order === 'ascend' ? 'ascending' : 'descending'
  }

  return null
}
